'use client';

import React from 'react';

interface MemoryPillProps {
  memory: { id?: string; title?: string; text?: string; url?: string } | null | undefined;
  index: number;
  maxLength?: number;
}

/** Glass-styled pill for memory/context references — shared by article and bubble render modes. */
export function MemoryPill({ memory, index, maxLength = 50 }: MemoryPillProps) {
  const label = memory?.title || memory?.text || memory?.url || `Context ${index + 1}`;
  return (
    <span className="memory-pill">
      {label.length > maxLength ? `${label.slice(0, maxLength - 3)}…` : label}
    </span>
  );
}

export default MemoryPill;
